<template>
    <b-card  align="left" class="border-0" header-bg-variant="white"  footer-bg-variant="white" header-border-variant="white" footer-border-variant="cBorder" body-border-variant="cBorder" border-variant="white" header-class=" text-left" body-class="p-0 rounded-top  border border-info" footer-class="border border-info border-top-0 rounded-bottom-1 p-0">
        <template v-slot:header>
            <b-card-title class="text-dark align-middle m-0  text-left" style="text-align: left;" >
                <b-img :src="icon"  v-bind="{ width: 35, height: 35, class: 'm1' }"  alt="Circle image"></b-img>
                政策数据地图
            </b-card-title>
        </template>
        <b-card-body class="p-0" >
            <b-row  class="p-0 m-0" cols-md>
                <b-col  class="" sm="12"   md="8">
                    <div ref="chart" style="width:100%;height:516px"></div>
                </b-col>
                <b-col  class="border-cBorder border-left border-opacity-25"  sm="12"  md="4">
                    <div ref="province" style="width:100%;height:516px"></div>
                </b-col>
            </b-row>
        </b-card-body>
        <template v-slot:footer>
            <b-row  class="p-0 m-0  text-center" >
                <b-col  cols="3" class="p-0">
                   <div class="text-white bg-cdark text-lg" style="line-height: 60px;"> {{provinceName + '省'}}</div>
                </b-col>
                <b-col  cols="9" class="p-0" style="line-height: 60px;">
                    <b-row  class="p-0 m-0 pl-2 pr-2" style="height: 60px;overflow: hidden;"  align-h="between">
                        <b-col  class="p-0 ">
                            <span class="text-dark font-weight-bold" style="max-width: 150px;">
                            政策录入 
                            </span>
                            <span class="text-primary font-weight-bold" style="max-width: 150px;">
                            {{allNum}}
                            </span>
                            <span class="text-dark font-weight-bold" style="max-width: 150px;">
                            条
                            </span>
                        </b-col>
                        <b-col  class="p-0" :class="{'animate-up': move}" id="valueList" >
                            <div  style="line-height: 30px;" v-for="(item,index) in list" :key="index">
                                <span class="text-dark font-weight-bold" style="max-width: 150px;">
                                    {{item.name}} 
                                </span>
                                <span class="text-primary font-weight-bold" style="max-width: 150px;">
                                    {{item.value}}
                                </span>
                                <span class="text-dark font-weight-bold" style="max-width: 150px;">
                                条
                                </span>
                            </div>
                        </b-col>
                        <b-col  class="p-0  d-none d-sm-block">
                            <span class="text-dark font-weight-bold" style="max-width: 150px;">
                            累计访问 
                            </span>
                            <span class="text-primary font-weight-bold" style="max-width: 150px;">
                            {{websiteTotalVisits || '126'}}
                            </span>
                            <span class="text-dark font-weight-bold" style="max-width: 150px;">
                            次
                            </span>
                        </b-col>
                    </b-row>
                </b-col>
            </b-row>
        </template>
    </b-card>
  </template>
  
  <script>
  import chinaJson from '@/assets/china.json';
  import shanXi from '@/assets/mapJson/140000.json'
import heNan from '@/assets/mapJson/410000.json'
import shannXi from '@/assets/mapJson/610000.json'
import xianzhuangicon from '@/assets/xianzhuangicon.png'

import { multi } from '@/api/api.js'
//使用name映射地图json文件
var IntervalTime =  null
const jsonMap = {
    '陕西': shannXi,
    '山西': shanXi,
    '河南': heNan
}
  export default {
    name: 'layout-unit-map',
    props: {
        navs: {
            type:Array,
            default(){
                return []
            }
        },
        brand:{
            type:Object,
            default(){
                return null
            }
        },
        variant:{
            type:String,
            default(){
                return 'primary'
            }
        },
        type:{
            type:String,
            default(){
                return 'dark'
            }
        },
        sticky:{
            type:Boolean,
            default(){
                return true
            }
        },
        fixed:{
            type:String,
            default(){
                return 'top'
            }
        },
        navItemAlign:{
            type:String,
            default(){
                return 'left'
            }
        }
    },
    mounted(){
        this.getTypeMulti()
        this.getMulti()
        // this.getEchartData()  
        
    },
    computed:{
        websiteTotalVisits(){
            let info = ''
            info = sessionStorage.getItem('basisInfo') ? this.bxDeepClone( JSON.parse(sessionStorage.getItem('basisInfo'))) : null

            if(info){
                info = info.total_visits
            }
            return info
        },
        optionsChina(){
            let options = {
                    backgroundColor: "transparent",
                    title: {
                        // text: "全国",
                        text: "{A|全国}",
                        // subtext: "全国",
                        // sublink: "http://www.pm25.in",
                        left: "left",
                        textStyle: {
                            color: "#000",
                            // backgroundColor: "linear-gradient(to top right, #f6f5f0, #fefefd)",
                            backgroundColor: {
                                image: require('../assets/logo.png'),
                            },
                            rich: {
                                A: {
                                    //添加背景图片并且设置宽高，会自适应显示
                                    width:140,
                                    height:40,
                                        padding:5,
                                    fontSize: "28",
                                    lineHeight:40,
                                    backgroundColor: {
                                        image: require("../assets/mapTitle.png")
                                    }
                                }
                            }
                        }
                        
                    },
                    tooltip: {
                        trigger: "item",
                        formatter: "{b}<br/>{c} "
                    },
                    //1),
                    //加上这个就可以实现多种颜色的功能
                    visualMap: {
                        type: 'piecewise', // 定义为分段型 visualMap
                        min: 0,
                        max: 100,
                        itemWidth: 40,
                        itemHeight: 20,
                        bottom: 10,
                        textStyle:{
                            fontSize:18
                        },
                        left: 10,
                        pieces: [ // 自定义『分段式视觉映射组件（visualMapPiecewise）』的每一段的范围，以及每一段的文字，以及每一段的特别的样式
                            {gt: 1, lte: 999, label: '第一阶段2023年', color: '#0cd1b6'}, // (900, 1000]
                            {gt: -1, lte: 1, label: '第二阶段2024年', color: '#0d6efd'}
                        ]
                    },
                    geo: { // 地理坐标系组件用于地图的绘制
                        map: 'china', // 表示中国地图
                        // roam: true, // 是否开启鼠标缩放和平移漫游
                        zoom: 1.2, // 当前视角的缩放比例（地图的放大比例）
                        label: {
                            show: true
                        },
                        itemStyle: { // 地图区域的多边形 图形样式。
                            borderColor: 'rgba(255, 255, 255, 0.8)',
                            emphasis: { // 高亮状态下的多边形和标签样式
                            shadowBlur: 20,
                            shadowColor: 'rgba(255, 255, 255, 0.8)'
                            }
                        }
                    },
                    
                    //series就是地图上的数据（去掉就没有数据了）
                    series: [
                    {
                        type: "map",
                        map: 'china',
                        geoIndex: 0,
                        aspectScale: 0.75, //长宽比
                        showLegendSymbol: false, // 存在legend时显示
                        label: {
                            normal: {
                                show: true,
                                formatter: function(params) {
                                     console.log(params,'params')
                                // return params.value + "\r\n" + params.name;
                                }
                            },
                            emphasis: {
                                show: false,
                                textStyle: {
                                color: "#fff"
                                }
                            }
                        },
                        roam: true,
                        animation: false,
                        data: this.provinceMapValue
                    },
                    ]
                }

                return options
        },
        optionsProvince(){
            let json = jsonMap[this.provinceName]
            let data = []
            if(json){
                //  this.getMulti()
                // console.log('getEchartProvinceData',json)
                json.features.map((item) =>{
                    let obj = {
                        name:item.properties.name,
                        value:0
                    }
                    data.push(obj)
                })
                for(let i of data){
                    for(let r of this.cityBy){
                        if(i.name == r.name){
                            i.value = r.value
                        }
                    }
                }
            }
            let options = {
                backgroundColor: "transparent",
                tooltip: {
                    trigger: "item",
                    formatter: "{b}<br/>{c} "
                },
                title: {
                    // text: "全国",
                    text: `{A|${this.provinceName}省}`,
                    // subtext: "全国",
                    // sublink: "http://www.pm25.in",
                    left: "left",
                    textStyle: {
                        color: "#000",
                        // backgroundColor: "linear-gradient(to top right, #f6f5f0, #fefefd)",
                        backgroundColor: {
                            image: require('../assets/logo.png'),
                        },
                        rich: {
                            A: {
                                //添加背景图片并且设置宽高，会自适应显示
                                width:140,
                                height:40,
                                fontSize: "28",
                                lineHeight:40,
                                padding:5,
                                backgroundColor: {
                                    image: require("../assets/mapTitle.png")
                                }
                            }
                        }
                    }
                    
                },
                geo: { // 地理坐标系组件用于地图的绘制
                    map: this.provinceName, // 表示中国地图
                    // roam: true, // 是否开启鼠标缩放和平移漫游
                    zoom: 1.0, // 当前视角的缩放比例（地图的放大比例）
                    label: {
                        normal: {
                            show:true,
                            textStyle: {
                                fontSize: 11,
                                color: '#000',
                                borderColor: '#fff',
                            }
                        },
                    },
                    itemStyle: { // 地图区域的多边形 图形样式。
                        borderColor: '#0a58ca',
                        areaColor: '#0cd1b6',  //这里是重点
                        emphasis: { // 高亮状态下的多边形和标签样式
                            shadowBlur: 20,
                            shadowColor: 'rgba(255, 255, 255, 0.8)'
                        }
                    }
                },
                visualMap: {
                    min: 0,
                    max: 100,
                    zoom: 0.8,
                    text: ['高', '低'],
                    realtime: false,
                    calculable: true,
                     left: "80%",
                    itemWidth: 15, //图形的宽度，即长条的宽度。
                    itemHeight: 60, //图形的高度，即长条的高度。
                    inRange: {
                      color: [ '#d4eaff','#0d6efd']
                    }
                  },
                //series就是地图上的数据（去掉就没有数据了）
                series: [
                    {
                        type: "map",
                        map: this.provinceName,
                        geoIndex: 0,
                        aspectScale: 0.75, //长宽比
                        showLegendSymbol: false, // 存在legend时显示
                        label: {
                            normal: {
                                show: false,
                                formatter: function(params) {
                                    console.log(params,'params')
                                // return params.value + "\r\n" + params.name;
                                }
                            },
                            emphasis: {
                                show: false,
                                textStyle: {
                                color: "#fff"
                                }
                            }
                        },
                        roam: false,
                        animation: false,
                        data: data
                    }
                ]
            }
              return options
        }
    },
    data() {
      return {
        icon:xianzhuangicon,
        move:false,
        provinceName:"",
        shhowList:[],
        list:[{
            id:1,
            name:"科技",
            value:0
        },{
            id:2,
            name:"人社",
            value:0
        },{
            id:3,
            name:"工信",
            value:0
        },{
            id:4,
            name:"发改",
            value:0
        },{
            id:5,
            name:"农业",
            value:0
        },{
            id:6,
            name:"商务",
            value:0
        },
        // {
        //     id:7,
        //     name:"税务",
        //     value:123
        // },
        {
            id:8,
            name:"其他",
            value:123
        }],
        reqTypeNums:[],
        allNum:0,
        provinceMapValue:[
            { name: "河南", value: 100 },
            { name: "山西", value: 100 },
            { name: "陕西", value: 100 },
            { name: "北京", value: 0 },
            { name: "天津", value: 0 },
            { name: "河北", value: 0 },
            { name: "内蒙古", value: 0 },
            { name: "辽宁", value: 0 },
            { name: "吉林", value: 0 },
            { name: "黑龙江", value: 0 },
            { name: "上海", value: 0 },
            { name: "江苏", value: 0 },
            { name: "浙江", value: 0 },
            { name: "安徽", value: 0 },
            { name: "福建", value: 0 },
            { name: "江西", value: 0 },
            { name: "山东", value: 0 },
            { name: "湖北", value: 0 },
            { name: "湖南", value: 0 },
            { name: "重庆", value: 0 },
            { name: "四川", value: 0 },
            { name: "贵州", value: 0 },
            { name: "云南", value: 0 },
            { name: "西藏", value: 0 },
            { name: "甘肃", value: 0 },
            { name: "青海", value: 0 },
            { name: "宁夏", value: 0 },
            { name: "新疆", value: 0 },
            { name: "广东", value: 0 },
            { name: "广西", value: 0 },
            { name: "海南", value: 0 },
            { name: "台湾", value: 0 }
        ],
        cityBy:[]
      }
    },
      methods: {
        getTypeMulti(){
            let req = [
                    {
                        "serviceName": "srvcosvc_policy_info_user_visitor_select",
                        "colNames": [
                            "*"
                        ],
                        "group":[ 
                            {
                                "colName": "province",
                                "type": "by"
                            },
                            {
                                "colName": "id",
                                "type": "count"
                            }
                        ],
                        "condition": [],
                        "page": {
                            "pageNo": 1,
                            "rownumber": 999
                        },
                        "order": []
                    }
                ]
                let app = 'fyzhmd'
            multi(req,app).then((res)=>{
                
                // console.log('---:',res)
                let resData = res.data
                if(res.state == "SUCCESS" && resData.length > 0){
                    let provinceBy = resData[0]
                    if(provinceBy.state == 'SUCCESS'){
                        for(let item of provinceBy.data){
                            for(let pMapVal of this.provinceMapValue){
                                if(item.province && item.province.indexOf(pMapVal.name) !== -1){
                                    // console.log(item.province,':',pMapVal.value,item.id)
                                    pMapVal.value = item.id
                                }
                            }
                        }
                    }
                }
            })
        },
        getMulti(){
            // IntervalTime
            
                
            let id = IntervalTime
                // console.log('定时器id',id)
                clearInterval(id)
                // console.log('重置定时器',clearInterval(id))
                IntervalTime = null
            let req = [
                    {
                        "serviceName": "srvcosvc_policy_info_user_visitor_select",
                        "colNames": [
                            "*"
                        ],
                        "group":[ 
                            {
                                "colName": "province",
                                "type": "count"
                            }
                        ],
                        "condition": [{
                            "colName":"province",
                            "ruleType":"[like]",
                            "value":this.provinceName
                        }],
                        "page": {
                            "pageNo": 1,
                            "rownumber": 999
                        },
                        "order": []
                    },
                    {
                        "serviceName": "srvcosvc_policy_info_user_visitor_select",
                        "colNames": [
                            "*"
                        ],
                        "group":[ 
                            {
                                "colName": "policy_sources_name",
                                "type": "by"
                            },
                            {
                                "colName": "id",
                                "type": "count"
                            }
                        ],
                        "condition": [{
                            "colName":"province",
                            "ruleType":"[like]",
                            "value":this.provinceName
                        }],
                        "relation_condition": {},
                        "page": {
                            "pageNo": 1,
                            "rownumber": 999
                        },
                        "order": []
                    },
                    {
                        "serviceName": "srvcosvc_policy_info_user_visitor_select",
                        "colNames": [
                            "*"
                        ],
                        "group":[ 
                            {
                                "colName": "city",
                                "type": "by"
                            },
                            {
                                "colName": "id",
                                "type": "count"
                            }
                        ],
                        "condition": [{
                            "colName":"province",
                            "ruleType":"[like]",
                            "value":this.provinceName
                        }],
                        "page": {
                            "pageNo": 1,
                            "rownumber": 999
                        },
                        "order": []
                    }
                ]
                let app = 'fyzhmd'
            multi(req,app).then((res)=>{
                
                // console.log('---:',res)
                let resData = res.data
                if(res.state == "SUCCESS" && resData.length > 0){
                    let allData = resData[0]
                    let typeData = resData[1]
                    let cityBy = resData[2]
                    if(typeData.state == 'SUCCESS'){
                        let typeNumber = resData[1].data 
                        // this.list = []
                        for(let item of this.list){
                                 item.value = 0
                            for(let i in typeNumber){
                               
                                if(item.name == typeNumber[i].policy_sources_name){
                                    item.value = typeNumber[i].id
                                }
                            }
                            // let itemData = {
                            //     id:i+1,
                            //     name:typeNumber[i].policy_sources_name,
                            //     value:typeNumber[i].id
                            // }
                            // this.list.push(itemData) 
                        }
                        // this.list = typeNumber.map((item,index) => {
                            
                        // })
                        
                        // 数据加载后开始
                        // this.startMove()
                        IntervalTime = setInterval(this.startMove, 1000)
                        // console.log('开始轮播:',IntervalTime)
                    }
                    if(allData.state == 'SUCCESS'){
                        
                        this.allNum = resData[0].data[0].province
                    }
                    if(cityBy.state == 'SUCCESS'){
                        this.cityBy = []
                        this.cityBy = cityBy.data.map(item => {
                            if(item.city){
                                
                                let obj = {
                                    name:item.city,
                                    value:item.id
                                }
                                return obj
                            }
                        })
                        this.cityBy = this.cityBy.filter(item => item)
                        // this.getEchartProvinceData(this.provinceName)

                    }
                    //  this.getEchartProvinceData(this.provinceName)
                }
            })
        },
        startMove() {
            let data = this.bxDeepClone(this.list[0])
                this.move = true //开始播放
            setTimeout(() => {
                
                this.list.shift() //删除第一条数据
                this.list.push(data) //将第一条数据塞到最后一个
                this.move = false //暂停播放,此处修改，保证每一次都会有动画显示
            }, 900)
        },
        getEchartData() {
            let self = this
            this.$echarts.registerMap("china", chinaJson);
            const chart = this.$refs.chart
            if (chart) {
                const myChart = this.$echarts.init(chart)
                // const data = this.provinceMapValue;
                const geoCoordMap = {
                    上海:  [121.472644, 31.231706],
                    云南:  [102.712251, 25.040609],
                    内蒙古:  [111.670801, 40.818311],
                    北京:  [116.405285, 39.904989],
                    台湾:  [121.509062, 25.044332],
                    吉林:  [125.3245, 43.886841],
                    四川:  [104.065735, 30.659462],
                    天津:  [117.190182, 39.125596],
                    宁夏:  [106.278179, 38.46637],
                    安徽:  [117.283042, 31.86119],
                    山东:  [117.000923, 36.675807],
                    山西:  [112.549248, 37.857014],
                    广东:  [113.280637, 23.125178],
                    广西:  [108.320004, 22.82402],
                    新疆:  [87.617733, 43.792818],
                    江苏:  [118.767413, 32.041544],
                    江西:  [115.892151, 28.676493],
                    河北:  [114.502461, 38.045474],
                    河南:  [113.665412, 34.757975],
                    浙江:  [120.153576, 30.287459],
                    海南:  [110.33119, 20.031971],
                    湖北:  [114.298572, 30.584355],
                    湖南:  [112.982279, 28.19409],
                    澳门:  [113.54909, 22.198951],
                    甘肃:  [103.823557, 36.058039],
                    福建:  [119.306239, 26.075302],
                    西藏:  [91.132212, 29.660361],
                    贵州:  [106.713478, 26.578343],
                    辽宁:  [123.429096, 41.796767],
                    重庆:  [106.504962, 29.533155],
                    陕西:  [108.948024, 34.263161],
                    青海:  [101.778916, 36.623178],
                    香港:  [114.173355, 22.320048],
                    黑龙江:  [126.642464, 45.756967],

                };
                var convertData = function(data) {
                    var res = [];
                    for (var i = 0; i < data.length; i++) {
                    var geoCoord = geoCoordMap[data[i].name];
                    if (geoCoord) {
                        res.push({
                        name: data[i].name,
                        value: geoCoord.concat(data[i].value)
                        });
                    }
                    }
                    console.log(res)
                    return res;
                };
                //5.echarts配置
                let option = this.optionsChina;
                myChart.setOption(option);
                self.getEchartProvinceData('陕西')
                window.addEventListener("resize", function() {
                    myChart.resize();
                });
                myChart.on("click", function(chinaParam) {
                    // console.log(chinaParam)
                    
                    self.provinceName = chinaParam.name
                    self.getMulti()
                    // self.getEchartProvinceData(chinaParam.name)
                });
            }
        },
        getEchartProvinceData(province) {
            let json = jsonMap[province]
            let data = []
            let geoCoordMap = {
            };
            if(json){
                this.provinceName = province
                
                //  this.getMulti()
                // console.log('getEchartProvinceData',json)
                json.features.map((item) =>{
                    geoCoordMap[item.properties.name] = item.properties.center
                })
                this.$echarts.registerMap(province, json);
                const chartTwo = this.$refs.province
                // console.log('getEchartProvinceData data',data,geoCoordMap)
                if (chartTwo) {
                    const myChartTwo = this.$echarts.init(chartTwo)
                    // const data = [
                        
                    // ];
                    const geoCoordMap = {
                    };
                    // var convertData = function(data) {
                    //     var res = [];
                    //     for (var i = 0; i < data.length; i++) {
                    //     var geoCoord = geoCoordMap[data[i].name];
                    //     if (geoCoord) {
                    //         res.push({
                    //         name: data[i].name,
                    //         value: geoCoord.concat(data[i].value)
                    //         });
                    //     }
                    //     }
                    //     console.log(res)
                    //     return res;
                    // };
                    //5.echarts配置
                    let option = this.optionsProvince;
                    myChartTwo.setOption(option);
                    window.addEventListener("resize", function() {
                        myChartTwo.resize();
                    });
                    myChartTwo.on("click", function(chinaParam) {
                        console.log(chinaParam)
                        // self.getEchartProvinceData(chinaParam.name)
                    });
                }
            }
            
        }
    },
    watch:{
        provinceMapValue:{
            deep:true,
            handler:function(nval,oval){
                this.getEchartData()
            }
        },
        cityBy:{
            deep:true,
            handler:function(nval,oval){
                this.getEchartProvinceData(this.provinceName)
            }
        },
        provinceName:{
            deep:true,
            handler:function(nval,oval){
                this.getEchartProvinceData(nval)
            }
        }
    }
  }
  </script>
  
  <!-- Add "scoped" attribute to limit CSS to this component only -->
  <style scoped>
  #valueList{
     height: 60px;
     /* overflow: hidden; */
  }
.animate-up {
    transition: all 0.5s ease-in-out;
    transform: translateY(-30px);
    
  }
  </style>
  